import { Skeleton } from '@/shared/ui'

import styles from './driver-recharge-loading.module.scss'

export const DriverRechargeLoading = (): React.ReactNode => {
    return (
        <div className={styles['driver-recharge-loading']}>
            <div className={styles['driver-recharge-loading__top']}>
                <Skeleton height={24} isLoading={true} width={'100%'} />
                <Skeleton
                    className={styles['driver-recharge-loading__top_amount']}
                    height={65}
                    isLoading={true}
                    width={140}
                />
                <Skeleton
                    borderRadius={40}
                    count={3}
                    direction='row'
                    gap={8}
                    height={40}
                    isLoading={true}
                    width={82}
                />
            </div>
            <div className={styles['driver-recharge-loading__bottom']}>
                <Skeleton height={24} isLoading={true} width={'100%'} />
                <Skeleton
                    className={styles['driver-recharge-loading__bottom_radio']}
                    height={56}
                    isLoading={true}
                    width={'100%'}
                />
                <Skeleton height={56} isLoading={true} width={'100%'} />
            </div>
        </div>
    )
}
